import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { CONFIRM_DIALOG_LABELS } from './delete-file-confirmation.constants';

@Component({
  selector: 'app-delete-file-confirmation-popup',
  templateUrl: './delete-file-confirmation-popup.component.html',
  styleUrls: ['./delete-file-confirmation-popup.component.scss'],
  standalone: false,
})
export class DeleteFileConfirmationPopupComponent {
  readonly IMAGES = IMAGE_SRC;
  readonly CONSTANTS = { ...CONFIRM_DIALOG_LABELS };

  constructor(
    @Inject(MAT_DIALOG_DATA) public fileName: string,
    public readonly dialog: MatDialog,
    public readonly dialogRef: MatDialogRef<DeleteFileConfirmationPopupComponent>,
  ) {}
}
